<template>
  <div class="page-wrap">
    <!-- 顶部筛选栏 -->
    <div class="search-card">
      <el-row :gutter="18">
        <el-col span="4">
          <el-form-item label="所属车间">
            <el-select v-model="search.workshop" clearable placeholder="全部">
              <el-option label="一车间" value="work1" />
              <el-option label="二车间" value="work2" />
              <el-option label="废气处理区" value="gasArea" />
              <el-option label="储罐区" value="tankArea" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="4">
          <el-form-item label="排放口编号">
            <el-input v-model="search.outlet" placeholder="输入排放口" />
          </el-form-item>
        </el-col>
        <el-col span="4">
          <el-form-item label="污染物类型">
            <el-select v-model="search.pollute" clearable placeholder="全部">
              <el-option label="非甲烷总烃" value="nmhc" />
              <el-option label="苯" value="benzene" />
              <el-option label="甲苯" value="toluene" />
              <el-option label="二甲苯" value="xylene" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="4">
          <el-form-item label="配置状态">
            <el-select v-model="search.status" clearable placeholder="全部">
              <el-option label="启用" value="1" />
              <el-option label="停用" value="0" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="btn-group">
        <el-button type="primary" class="btn-main" @click="queryTable"
          >查询</el-button
        >
        <el-button @click="resetSearch">重置</el-button>
        <el-button type="success" @click="openAddDialog"
          >新增阈值配置</el-button
        >
        <el-button @click="openBatchDialog">批量修改阈值</el-button>
        <el-button type="warning" @click="batchStandard"
          >批量套用国标阈值</el-button
        >
        <el-button @click="refreshTable">刷新</el-button>
        <el-button type="info" @click="exportConfig">导出全部配置</el-button>
      </div>
    </div>

    <!-- 阈值配置主表格 -->
    <div class="table-container">
      <el-table
        :data="tableData"
        border
        class="data-table"
        @row-click="openLog"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="设备编号" prop="equipCode" width="110" />
        <el-table-column label="设备名称" prop="equipName" min-width="130" />
        <el-table-column label="排放口" prop="outletNo" width="100" />
        <el-table-column label="污染物" prop="polluteName" width="100" />
        <el-table-column label="测量量程" prop="range" width="100" />
        <el-table-column label="预警阈值(50%限值)" prop="warnVal" width="120" />
        <el-table-column label="高报阈值(80%限值)" prop="highVal" width="120" />
        <el-table-column
          label="紧急阈值(100%限值)"
          prop="urgentVal"
          width="120"
        />
        <el-table-column label="触发持续时长(s)" prop="delayTime" width="130" />
        <el-table-column label="短信推送" prop="smsEnable" width="90">
          <template #default="scope">
            <el-tag :type="scope.row.smsEnable ? 'success' : 'info'">
              {{ scope.row.smsEnable ? "开启" : "关闭" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" width="80">
          <template #default="scope">
            <el-tag :type="scope.row == 1 ? 'success' : 'danger'">
              {{ scope.row.status == 1 ? "启用" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="更新人" prop="updateUser" width="90" />
        <el-table-column label="更新时间" prop="updateTime" width="160" />
        <el-table-column label="操作" fixed="right" width="220">
          <template #default="scope">
            <el-button size="small" @click.stop="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button size="small" type="info" @click.stop="openLog(scope.row)"
              >变更日志</el-button
            >
            <el-button
              size="small"
              type="danger"
              v-if="scope.status === 1"
              @click.stop="stopConfig(scope.row)"
              >停用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增/编辑阈值弹窗 -->
    <el-dialog
      v-model="dialogVisible"
      title="VOC阈值配置编辑"
      width="780"
      class="dark-dialog"
    >
      <el-form :model="formData" label-width="140">
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="设备编号">
              <el-input v-model="formData.equipCode" :disabled="formData.id" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="设备名称">
              <el-input v-model="formData.equipName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="所属排放口">
              <el-input v-model="formData.outletNo" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="污染物类型">
              <el-select v-model="formData.polluteType">
                <el-option label="非甲烷总烃" value="nmhc" />
                <el-option label="苯" value="benzene" />
                <el-option label="甲苯" value="toluene" />
                <el-option label="二甲苯" value="xylene" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="设备测量量程(mg/m³)">
          <el-input-number v-model="formData.range" min="0" step="0.1" />
        </el-form-item>
        <el-row :gutter="20">
          <el-col span="8">
            <el-form-item label="预警阈值(低报)">
              <el-input-number v-model="formData.warnVal" min="0" step="0.1" />
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="高报阈值">
              <el-input-number v-model="formData.highVal" min="0" step="0.1" />
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="紧急阈值(超标)">
              <el-input-number
                v-model="formData.urgentVal"
                min="0"
                step="0.1"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="触发持续时长(秒，过滤瞬时波动)">
          <el-input-number v-model="formData.delayTime" min="0" />
        </el-form-item>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="短信告警推送">
              <el-switch v-model="formData.smsEnable" />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="配置启用状态">
              <el-switch
                v-model="formData.status"
                active-text="启用"
                inactive-text="停用"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注说明">
          <el-input v-model="formData.remark" type="textarea" rows="3" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveForm">保存配置</el-button>
      </template>
    </el-dialog>

    <!-- 批量修改弹窗 -->
    <el-dialog
      v-model="batchVisible"
      title="批量同步VOC阈值参数"
      width="660"
      class="dark-dialog"
    >
      <el-form :model="batchForm" label-width="140">
        <el-form-item label="预警阈值">
          <el-input-number v-model="batchForm.warnVal" min="0" step="0.1" />
        </el-form-item>
        <el-form-item label="高报阈值">
          <el-input-number v-model="batchForm.highVal" min="0" step="0.1" />
        </el-form-item>
        <el-form-item label="紧急阈值">
          <el-input-number v-model="batchForm.urgentVal" min="0" step="0.1" />
        </el-form-item>
        <el-form-item label="持续过滤时长(秒)">
          <el-input-number v-model="batchForm.delayTime" min="0" />
        </el-form-item>
        <el-form-item label="批量开启短信推送">
          <el-switch v-model="batchForm.smsEnable" />
        </el-form-item>
        <el-form-item label="应用范围">
          <el-radio-group v-model="batchScope">
            <el-radio label="当前筛选全部设备" />
            <el-radio label="表格勾选设备" />
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="batchVisible = false">取消</el-button>
        <el-button type="primary" @click="saveBatch">批量覆盖保存</el-button>
      </template>
    </el-dialog>

    <!-- 阈值变更日志弹窗 -->
    <el-dialog
      v-model="logVisible"
      title="阈值变更追溯日志（不可删除）"
      width="880"
      class="dark-dialog"
    >
      <el-table :data="logList" border stripe height="360" class="data-table">
        <el-table-column label="修改时间" prop="time" width="170" />
        <el-table-column label="操作人" prop="user" width="100" />
        <el-table-column label="污染物" prop="pollute" width="100" />
        <el-table-column label="修改项" prop="field" width="120" />
        <el-table-column label="旧值" prop="old" width="110" />
        <el-table-column label="新值" prop="new" width="110" />
        <el-table-column label="操作备注" prop="remark" min-width="180" />
      </el-table>
      <template #footer>
        <el-button @click="logVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="js">
import { ref, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'

// 分页
const pageNum = ref(1)
const tableTotal = ref(52)
// 搜索条件
const search = reactive({
  workshop: '',
  outlet: '',
  pollute: '',
  status: ''
})
// 表格模拟数据
const tableData = ref([
  {
    id: 1,
    equipCode: 'VOC-001',
    equipName: '一车间排放口在线监测仪',
    outletNo: 'OUT-01',
    polluteType: 'nmhc',
    polluteName: '非甲烷总烃',
    range: 200,
    warnVal: 30,
    highVal: 48,
    urgentVal: 60,
    delayTime: 15,
    smsEnable: true,
    status: 1,
    updateUser: '张运维',
    updateTime: '2026-07-28 16:22',
    remark: '国标80%高报限值配置'
  },
  {
    id: 2,
    equipCode: 'VOC-003',
    equipName: '废气区二号监测设备',
    outletNo: 'OUT-03',
    polluteType: 'benzene',
    polluteName: '苯',
    range: 50,
    warnVal: 1,
    highVal: 1.6,
    urgentVal: 2,
    delayTime: 10,
    smsEnable: false,
    status: 1,
    updateUser: '李主管',
    updateTime: '2026-07-25 09:10',
    remark: ''
  },
  {
    id: 3,
    equipCode: 'VOC-005',
    equipName: '储罐区监测探头',
    outletNo: 'OUT-05',
    polluteType: 'xylene',
    polluteName: '二甲苯',
    range: 100,
    warnVal: 10,
    highVal: 16,
    urgentVal: 20,
    delayTime: 20,
    smsEnable: true,
    status: 0,
    updateUser: '王工',
    updateTime: '2026-07-20 14:05',
    remark: '设备检修临时停用'
  }
])

// 新增/编辑表单
const dialogVisible = ref(false)
const formData = reactive({
  id: '',
  equipCode: '',
  equipName: '',
  outletNo: '',
  polluteType: 'nmhc',
  range: 200,
  warnVal: 30,
  highVal: 48,
  urgentVal: 60,
  delayTime: 15,
  smsEnable: true,
  status: true,
  remark: ''
})

// 批量配置
const batchVisible = ref(false)
const batchScope = ref('all')
const batchForm = reactive({
  warnVal: 30,
  highVal: 48,
  urgentVal: 60,
  delayTime: 15,
  smsEnable: true
})

// 变更日志
const logVisible = ref(false)
const logList = ref([
  { time: '2026-07-28 16:22', user: '张运维', pollute: '非甲烷总烃', field: '高报阈值', old: 40, new: 48, remark: '更新国标限值' },
  { time: '2026-07-28 16:22', user: '张运维', pollute: '非甲烷总烃', field: '短信推送', old: false, new: true, remark: '开启告警短信' }
])

// 查询
const queryTable = () => {
  ElMessage.success('筛选查询完成')
  pageNum.value = 1
}
// 重置
const resetSearch = () => {
  search.workshop = ''
  search.outlet = ''
  search.pollute = ''
  search.status = ''
}
// 刷新
const refreshTable = () => ElMessage.success('数据已刷新')
// 导出
const exportConfig = () => ElMessage.success('VOC阈值配置Excel导出成功')
// 批量套用国标
const batchStandard = () => ElMessage.success('已批量加载国标分级阈值模板')

// 新增弹窗
const openAddDialog = () => {
  dialogVisible.value = true
  Object.assign(formData, {
    id: '', equipCode: '', equipName: '', outletNo: '', polluteType: 'nmhc',
    range: 200, warnVal: 30, highVal: 48, urgentVal: 60, delayTime: 15,
    smsEnable: true, status: true, remark: ''
  })
}
// 编辑弹窗
const openEditDialog = (row) => {
  dialogVisible.value = true
  Object.assign(formData, row)
  form.status = row.status === 1
}
// 保存单条
const saveForm = () => {
  formData.status = formData.status ? 1 : 0
  ElMessage.success(formData.id ? '阈值配置修改完成，变更日志已记录' : '新增VOC阈值配置成功')
  dialogVisible.value = false
}

// 批量弹窗
const openBatchDialog = () => batchVisible.value = true
const saveBatch = () => {
  ElMessage.success('批量阈值覆盖完成，所有变更已留存日志')
  batchVisible.value = false
}

// 停用配置
const stopConfig = (row) => {
  ElMessageBox.confirm(`确认停用【${row.equipName}】阈值告警？停用后不再推送报警`).then(() => {
    row.status = 0
    ElMessage.success('已停用，变更记录已保存')
  })
}

// 打开变更日志
const openLog = () => logVisible.value = true
</script>

<style>
/* 顶部筛选卡片 */
.search-card {
  background: var(--bg-search);
  border: 1px solid rgba(64, 158, 255, 0.22);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}
.search-card :deep(.el-form-item label) {
  color: var(--text-sub);
}
.btn-group {
  margin-top: 16px;
  display: flex;
  gap: 12px;
}
.btn-main {
  background: var(--grad-blue);
  border: none;
}
/* 表格区域 */
.table-container {
  width: 100%;
}

.dark-page :deep(.el-pagination) {
  color: var(--text-sub);
}
/* 弹窗通用深色 */
.dark-dialog :deep(.el-dialog) {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
}
.dark-dialog :deep(.el-dialog__title) {
  color: #fff;
}
.dark-dialog :deep(.el-form-item label) {
  color: var(--text-sub);
}
</style>
